export type RecordTimelineEvent = {
  id: string;
  action: string;
  description: string;
  createdAt: string;
  module: string;
  actorName?: string | null;
  actorId?: string | null;
  actorType?: string | null;
};

type RecordTimelineProps = {
  events: RecordTimelineEvent[];
  emptyMessage: string;
};

function actorLabel(event: RecordTimelineEvent) {
  if (event.actorName) return event.actorName;
  if (event.actorId) return event.actorId;
  if (event.actorType === "human") return "Human";
  if (event.actorType === "ai") return "AI";
  return "System";
}

export function RecordTimeline({ events, emptyMessage }: RecordTimelineProps) {
  if (events.length === 0) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-4 text-sm text-gray-500 dark:border-white/10 dark:bg-white/5 dark:text-gray-400">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {events.map((event) => (
        <article key={event.id} className="rounded-lg border border-gray-200 bg-white p-4 dark:border-white/10 dark:bg-white/5">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="text-sm font-semibold capitalize">{event.action.replace(/-/g, " ")}</p>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {event.createdAt ? new Date(event.createdAt).toLocaleString() : "—"}
            </p>
          </div>
          <p className="mt-2 whitespace-pre-wrap text-sm text-gray-700 dark:text-gray-200">{event.description}</p>
          <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
            {event.module} · {actorLabel(event)}
          </p>
        </article>
      ))}
    </div>
  );
}
